import { AxiosRequestConfig } from 'axios';
import { useMutation } from 'react-query';
import { axiosDefaultApi } from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';


const uploadFile = ({uploadedFile, formParameters}: {uploadedFile: FormData, formParameters: IBillingUploadForm}): Promise<any> => {
  const config: AxiosRequestConfig = {
    headers: { 'Content-Type': 'multipart/form-data' }
  };

  return axiosDefaultApi.post(`/api/Billing/Upload?Month=${formParameters.month}&Year=${formParameters.year}&ProviderID=${formParameters.providerID}`, uploadedFile, config);
};

type QueryFnType = typeof uploadFile;

type UseUploadFileOptions = {
  uploadedFile: FormData;
  formParameters: IBillingUploadForm;
  config?: MutationConfig<QueryFnType>; 
};

export const useUploadFile = ({ config }: UseUploadFileOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useMutation({
    mutationFn: uploadFile,
    onError: (error: any) => {
      const userError = error.response.data ? error.response.data : "Υπήρξε πρόβλημα στο ανέβασμα του αρχείου.";
      addNotification(userError, 400, 'Modal');
      setIsNotificationVisible(true);
      console.error('An error occurred while uploading the file:', error);
    },
    onSuccess: () => {
      addNotification(`Επιτυχής εισαγωγή.`, 200);
      setIsNotificationVisible(true);
      console.log('File uploaded successfully.');
    },
    ...config,
  });
};